




























































































































































































































































































import { Component, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import FilterSelect from '@/components/FilterSelect.vue';
import * as s_manageGroups_Interface from '@/interface/store/manageGroups';
import { InventoryQueryParams } from '@/interface/store/inventory';
import { RequestQueryParams } from '@/interface/store/request';

const namespace: string = 'manageGroup';

@Component({
  components: {
    FilterSelect,
  },
})
export default class SideFilter extends Vue {
  @PropSync('isFilterOn', { type: Boolean }) syncedIsFilterOn!: boolean;

  @Action('getInventory', { namespace: 'inventory' }) c_getInventory!: any;
  @Action('getRequests', { namespace: 'request' }) c_getRequests!: any;
  @Action('getQueryParams', { namespace: 'inventory' }) c_getInventoryQueryParams!: any;
  @Action('getQueryParams', { namespace: 'request' }) c_getRequestQueryParams!: any;

  @Getter('getterGroupsMemberships', { namespace }) c_getterGroupsMemberships!: Array<
    s_manageGroups_Interface.GroupItem
  >;
  @Getter('getterLastGroupId') c_getterLastGroupId!: any;
  @Getter('getterTypes', { namespace }) c_getterTypes!: Array<s_manageGroups_Interface.TypeData>;
  @Getter('getterGrants', { namespace }) c_getterGrants!: Array<s_manageGroups_Interface.GrantData>;
  @Getter('getterVendors', { namespace }) c_getterVendors!: Array<
    s_manageGroups_Interface.VendorData
  >;
  @Getter('getterManufacturers', { namespace }) c_getterManufacturers!: Array<
    s_manageGroups_Interface.ManufacturerData
  >;
  @Getter('getterMainLocations', { namespace }) c_getterMainLocations!: Array<
    s_manageGroups_Interface.MainLocationData
  >;
  @Getter('getterMembers', { namespace }) c_getterMembers!: Array<s_manageGroups_Interface.Member>;
  @Getter('getterQueryParams', { namespace: 'inventory' })
  readonly c_getterInventoryQueryParams!: InventoryQueryParams;
  @Getter('getterQueryParams', { namespace: 'request' })
  readonly c_getterRequestQueryParams!: RequestQueryParams;

  @Mutation('SET_REQUEST_FILTER', { namespace: 'request' }) c_SET_REQUEST_FILTER!: any;
  @Mutation('SET_INVENTORY_FILTER', { namespace: 'inventory' }) c_SET_INVENTORY_FILTER!: any;

  public isShow: boolean = false;
  public dialogVisibleExport: boolean = false;

  public inventoryAttributes: string =
    'id,name,serialNumber,catalogNumber,unit,unitSize,quantity,price,ownedBy,url,casNumber,lotNumber,expiresOn,technicalDetails,boughtFrom,expirationReminder,customFields,vendorName,isArchived,createdBy,createdAt,updatedBy,updatedAt,lastReceivedAt,fkTypeId,fkVendorId,fkLocationId,fkLocationSubId,notes';
  public inventoryLimit: number = 20;
  public inventoryOffset: number = 0;
  public inventorySort: string = '-updatedAt';
  public inventoryInclude: string = 'fkType,fkVendor,fkLocation,fkLocationSub,fkOwnedBy';
  public inventoryKeyword: string = '';

  public queryAttributes: string =
    'id,catalogNumber,name,url,unitSize,quantity,quantityReceived,price,createdBy,isUrgent,requiredBefore,requisitionNumber,confirmationNumber,trackingNumber,invoiceNumber,statusChangedAt,fkTypeId,notes,createdAt,status,updatedAt,fkVendorId,requestedBy,fkPurchaseOrderId,expectedOn';
  public queryLimit: number = 20;
  public queryOffset: number = 0;
  public querySort: string = '-statusChangedAt';
  public queryInclude: string = 'fkType,fkVendor,fkRequestedBy,fkPurchaseOrder';
  public queryKeyword: string = '';
  public queryHasDropdown: boolean = false;

  public inventoryFilterStack: any = {
    Locations: [],
    Vendors: [],
    Manufacturers: [],
    Types: [],
    Users: [],
  };

  public showInventoryFilters: any = {
    Locations: false,
    Vendors: false,
    Manufacturers: false,
    Types: false,
    Users: false,
  };

  public inventoryFilterObject = {
    Locations: {
      mainArray: [],
      subArray: [],
    },
    Vendors: {
      subArray: [],
    },
    Manufacturers: {
      subArray: [],
    },
    Types: {
      subArray: [],
    },
    Users: {
      subArray: [],
    },
  };

  public requestFilterStack: any = {
    Vendors: [],
    Manufacturers: [],
    Types: [],
    Users: [],
    Grants: [],
  };

  public showRequestFilters: any = {
    Vendors: false,
    Manufacturers: false,
    Types: false,
    Users: false,
    Grants: false,
  };

  public requestFilterObject = {
    Vendors: {
      subArray: [],
    },
    Manufacturers: {
      subArray: [],
    },
    Types: {
      subArray: [],
    },
    Users: {
      subArray: [],
    },
    Grants: {
      subArray: [],
    },
  };

  created() {
    const { attributes, limit, offset, sort, include, query, hasDropdown }: any = this.$route.query;
    if (this.$route.name !== 'ContentView') {
      if (attributes) this.queryAttributes = attributes;
      if (limit) this.queryLimit = limit;
      if (offset) this.queryOffset = offset;
      if (sort) this.querySort = sort;
      if (include) this.queryInclude = include;
      if (query) this.queryKeyword = query;
      if (hasDropdown) this.queryHasDropdown = hasDropdown;
    } else {
      if (attributes) this.inventoryAttributes = attributes;
      if (limit) this.inventoryLimit = limit;
      if (offset) this.inventoryOffset = offset;
      if (sort) this.inventorySort = sort;
      if (include) this.inventoryInclude = include;
      if (query) this.inventoryKeyword = query;
    }
  }

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange(val: any, oldVal: any) {
    if (!oldVal) return false;
    const { attributes, limit, offset, sort, include, query, hasDropdown }: any = val.query;
    if (val.name !== 'ContentView') {
      if (attributes) this.queryAttributes = attributes;
      if (limit) this.queryLimit = limit;
      if (offset) this.queryOffset = offset;
      if (sort) this.querySort = sort;
      if (include) this.queryInclude = include;
      if (query) {
        this.queryKeyword = query;
      } else {
        this.queryKeyword = '';
      }
      if (hasDropdown) this.queryHasDropdown = hasDropdown;
    } else {
      if (attributes) this.inventoryAttributes = attributes;
      if (limit) this.inventoryLimit = limit;
      if (offset) this.inventoryOffset = offset;
      if (sort) this.inventorySort = sort;
      if (include) this.inventoryInclude = include;
      if (query) {
        this.inventoryKeyword = query;
      } else {
        this.inventoryKeyword = '';
      }
    }
  }

  get currentGroupName() {
    let currentName: string = '';
    const groupId: string = this.$route.params.groupId;
    if (groupId === 'welcome' || this.c_getterGroupsMemberships.length < 1) currentName = 'Welcome';
    else {
      if (this.c_getterGroupsMemberships.length > 0) {
        currentName = this.c_getterGroupsMemberships.find((v: any) => v.fkGroup.id === groupId)!
          .fkGroup.name;
      }
    }
    return currentName;
  }

  get groupMembers() {
    let newArr: any = [];
    this.c_getterMembers
      .filter((member) => member.status === 'ACTIVE')
      .map((member) => {
        const copy = Object.assign({}, member.fkUser);
        newArr.push(copy);
      });
    return newArr.map((obj: any) => {
      obj['name'] = obj['fullName'];
      delete obj['fullName'];
      return obj;
    });
  }

  async exportData() {
    this.$root.$emit('isExportModal', true);
  }

  async importData() {
    this.$root.$emit('isImportModal', true);
  }

  showOnlyOneFilterSelect(clickedFilterName: string) {
    for (const filterName in this.showInventoryFilters) {
      if (clickedFilterName === filterName) {
        this.showInventoryFilters[filterName] = !this.showInventoryFilters[filterName];
      } else {
        this.showInventoryFilters[filterName] = filterName === clickedFilterName;
      }
    }
    return this.showInventoryFilters;
  }

  showOnlyOneRequestFilterSelect(clickedFilterName: string) {
    for (const filterName in this.showRequestFilters) {
      if (clickedFilterName === filterName) {
        this.showRequestFilters[filterName] = !this.showRequestFilters[filterName];
      } else {
        this.showRequestFilters[filterName] = filterName === clickedFilterName;
      }
    }
    return this.showRequestFilters;
  }

  checkIfFiltered() {
    const name = this.$route.name;

    if (name === 'ContentView') {
      for (const filter in this.inventoryFilterStack) {
        if (this.inventoryFilterStack[filter].length) {
          this.syncedIsFilterOn = true;
          return true;
        }
      }

      this.syncedIsFilterOn = false;
      return false;
    } else {
      for (const filter in this.requestFilterStack) {
        if (this.requestFilterStack[filter].length) {
          this.syncedIsFilterOn = true;
          return true;
        }
      }

      this.syncedIsFilterOn = false;
      return false;
    }
  }

  async groupSwitching(item: any) {
    const routeObj: any = {
      path: `/groups/${item.fkGroup.id}/inventory`,
      query: {},
    };

    this.requestFilterStack = {
      Vendors: [],
      Manufacturers: [],
      Types: [],
      Users: [],
      Grants: [],
    };

    this.requestFilterObject = {
      Vendors: {
        subArray: [],
      },
      Manufacturers: {
        subArray: [],
      },
      Types: {
        subArray: [],
      },
      Users: {
        subArray: [],
      },
      Grants: {
        subArray: [],
      },
    };

    this.inventoryFilterStack = {
      Locations: [],
      Vendors: [],
      Manufacturers: [],
      Types: [],
      Users: [],
    };
    this.inventoryFilterObject = {
      Locations: {
        mainArray: [],
        subArray: [],
      },
      Vendors: {
        subArray: [],
      },
      Manufacturers: {
        subArray: [],
      },
      Types: {
        subArray: [],
      },
      Users: {
        subArray: [],
      },
    };

    this.c_SET_REQUEST_FILTER({});
    this.c_SET_INVENTORY_FILTER({});

    if (this.$route.name !== 'ContentView') {
      await this.c_getRequestQueryParams({ groupId: item.fkGroup.id });
      const { hasDropdown, limit, offset, order, status } = this.c_getterRequestQueryParams;
      Object.assign(routeObj, {
        path: `/groups/${item.fkGroup.id}/requests`,
        query: {
          limit,
          page: offset + 1,
          sort: order,
        },
      });

      if (status) {
        routeObj.query = Object.assign({ status: status.split(',') }, routeObj.query);
      }

      if (hasDropdown) {
        Object.assign(routeObj.query, {
          hasDropdown,
        });
      }
    } else {
      await this.c_getInventoryQueryParams({ groupId: item.fkGroup.id });
      Object.assign(routeObj, {
        path: `/groups/${item.fkGroup.id}/inventory`,
        query: {
          limit: this.c_getterInventoryQueryParams.limit,
          page: this.c_getterInventoryQueryParams.offset + 1,
          sort: this.c_getterInventoryQueryParams.order,
        },
      });
    }
    this.$root.$emit('rootResetFilter');
    await this.$router.push(routeObj);
  }

  mounted() {
    this.anyWhereClose('labSwap');
    this.$root.$on('rootEmitDeleteAllInventoryFilters', (bool: boolean) => {
      this.deleteAllInventoryFilters();
    });
    this.$root.$on('rootEmitDeleteAllRequestFilters', (bool: boolean) => {
      this.deleteAllRequestFilters();
    });
  }

  updated() {
    if (this.isShow) {
      const currentItemElement = document.getElementsByClassName('current-item')[0];

      if (currentItemElement) {
        currentItemElement.scrollIntoView({ behavior: 'auto', block: 'center' });
      }
    }
  }

  anyWhereClose(refName: string) {
    document.addEventListener('click', (e: any) => {
      if ((this.$refs[refName] as HTMLElement) !== undefined) {
        if (
          !e.target.dataset.hasOwnProperty('currentSelect') &&
          !(this.$refs[refName] as HTMLElement).contains(e.target)
        ) {
          this.isShow = false;
        }
      }
    });
  }

  async deleteInventoryTag(item: any, filterName: string) {
    const groupId: string = this.$route.params.groupId;
    this.inventoryFilterStack[filterName].splice(
      this.inventoryFilterStack[filterName].indexOf(item),
      1
    );
    const mainArray: any = [];
    const subArray: any = [];
    const stash = this.inventoryFilterStack.Locations;
    switch (filterName) {
      case 'Locations':
        for (let i = 0; i < stash.length; i += 1) {
          if (stash[i].hasOwnProperty('fkLocationSub')) {
            mainArray.push(stash[i].id);
            stash[i].fkLocationSub.map((item: any) => subArray.push(item.id));
          } else {
            subArray.push(stash[i].id);
          }
        }
        Object.assign(this.inventoryFilterObject.Locations, {
          mainArray,
          subArray,
        });
        break;
      case 'Types':
        Object.assign(this.inventoryFilterObject.Types, {
          subArray: this.inventoryFilterStack.Types.map((item: any) => item.id),
        });
        break;
      case 'Vendors':
        Object.assign(this.inventoryFilterObject.Vendors, {
          subArray: this.inventoryFilterStack.Vendors.map((item: any) => item.id),
        });
        break;
      case 'Manufacturers':
        Object.assign(this.inventoryFilterObject.Manufacturers, {
          subArray: this.inventoryFilterStack.Manufacturers.map((item: any) => item.id),
        });
        break;
      case 'Users':
        Object.assign(this.inventoryFilterObject.Users, {
          subArray: this.inventoryFilterStack.Users.map((item: any) => item.id),
        });
        break;
    }
    await this.c_SET_INVENTORY_FILTER(this.inventoryFilterObject);
    await this.c_getInventory({
      groupId,
      attributes: this.inventoryAttributes,
      offset: this.inventoryOffset,
      limit: this.inventoryLimit,
      order: this.inventorySort,
      include: this.inventoryInclude,
      filters: this.inventoryFilterObject,
      query: this.inventoryKeyword,
    });
  }

  async deleteRequestTag(item: any, filterName: string) {
    const groupId: string = this.$route.params.groupId;
    const status: any = this.$route.query.status;
    this.requestFilterStack[filterName].splice(
      this.requestFilterStack[filterName].indexOf(item),
      1
    );
    switch (filterName) {
      case 'Types':
        Object.assign(this.requestFilterObject.Types, {
          subArray: this.requestFilterStack.Types.map((item: any) => item.id),
        });
        break;
      case 'Vendors':
        Object.assign(this.requestFilterObject.Vendors, {
          subArray: this.requestFilterStack.Vendors.map((item: any) => item.id),
        });
        break;
      case 'Manufacturers':
        Object.assign(this.requestFilterObject.Manufacturers, {
          subArray: this.requestFilterStack.Manufacturers.map((item: any) => item.id),
        });
        break;
      case 'Users':
        Object.assign(this.requestFilterObject.Users, {
          subArray: this.requestFilterStack.Users.map((item: any) => item.id),
        });
        break;
      case 'Grants':
        Object.assign(this.requestFilterObject.Grants, {
          subArray: this.requestFilterStack.Grants.map((item: any) => item.id),
        });
        break;
    }
    await this.c_SET_REQUEST_FILTER(this.requestFilterObject);
    await this.c_getRequests({
      groupId,
      attributes: this.queryAttributes,
      offset: this.queryOffset,
      limit: this.queryLimit,
      order: this.querySort,
      include: this.queryInclude,
      filters: this.requestFilterObject,
      status: {
        status,
      },
      query: this.queryKeyword,
      hasDropdown: this.queryHasDropdown,
    });
  }

  async onCheckInventoryFilterItem({ stash, filterName, mainArray, subArray }: any) {
    this.inventoryFilterStack[filterName] = stash;
    const groupId: string = this.$route.params.groupId;
    switch (filterName) {
      case 'Locations':
        Object.assign(this.inventoryFilterObject.Locations, { mainArray, subArray });
        break;
      case 'Vendors':
        Object.assign(this.inventoryFilterObject.Vendors, { subArray });
        break;
      case 'Manufacturers':
        Object.assign(this.inventoryFilterObject.Manufacturers, { subArray });
        break;
      case 'Types':
        Object.assign(this.inventoryFilterObject.Types, { subArray });
        break;
      case 'Users':
        Object.assign(this.inventoryFilterObject.Users, { subArray });
        break;
    }
    await this.c_SET_INVENTORY_FILTER(this.inventoryFilterObject);
    await this.c_getInventory({
      groupId,
      attributes: this.inventoryAttributes,
      offset: this.inventoryOffset,
      limit: this.inventoryLimit,
      order: this.inventorySort,
      include: this.inventoryInclude,
      filters: this.inventoryFilterObject,
      query: this.inventoryKeyword,
    });
  }

  async onCheckRequestFilterItem({ stash, filterName, subArray }: any) {
    this.requestFilterStack[filterName] = stash;
    const groupId: string = this.$route.params.groupId;
    const status: any = this.$route.query.status;
    switch (filterName) {
      case 'Vendors':
        Object.assign(this.requestFilterObject.Vendors, { subArray });
        break;
      case 'Manufacturers':
        Object.assign(this.requestFilterObject.Manufacturers, { subArray });
        break;
      case 'Types':
        Object.assign(this.requestFilterObject.Types, { subArray });
        break;
      case 'Users':
        Object.assign(this.requestFilterObject.Users, { subArray });
        break;
      case 'Grants':
        Object.assign(this.requestFilterObject.Grants, { subArray });
        break;
    }
    await this.c_SET_REQUEST_FILTER(this.requestFilterObject);
    await this.c_getRequests({
      groupId,
      attributes: this.queryAttributes,
      offset: this.queryOffset,
      limit: this.queryLimit,
      order: this.querySort,
      include: this.queryInclude,
      status: {
        status,
      },
      filters: this.requestFilterObject,
      query: this.queryKeyword,
      hasDropdown: this.queryHasDropdown,
    });
  }

  showHideList() {
    this.isShow ? (this.isShow = false) : (this.isShow = true);
  }

  createLab() {
    this.$root.$emit('createLab', true);
    this.isShow = false;
  }

  addInventoryItem() {
    if (this.$route.params.groupId === 'welcome') {
      this.$message.warning('LAB을 생성해주세요.');
      return false;
    }
    this.$root.$emit('rootEmitAddInventoryItem');
  }

  addRequestItem() {
    if (this.$route.params.groupId === 'welcome') {
      this.$message.warning('LAB을 생성해주세요.');
      return false;
    }
    this.$root.$emit('rootEmitAddRequestItem');
  }

  async deleteAllInventoryFilters() {
    const groupId: string = this.$route.params.groupId;
    this.inventoryFilterStack = {
      Locations: [],
      Vendors: [],
      Manufacturers: [],
      Types: [],
      Users: [],
    };
    this.inventoryFilterObject = {
      Locations: {
        mainArray: [],
        subArray: [],
      },
      Vendors: {
        subArray: [],
      },
      Manufacturers: {
        subArray: [],
      },
      Types: {
        subArray: [],
      },
      Users: {
        subArray: [],
      },
    };
    this.c_SET_INVENTORY_FILTER({});
    await this.c_getInventory({
      groupId,
      attributes: this.inventoryAttributes,
      offset: this.inventoryOffset,
      limit: this.inventoryLimit,
      order: this.inventorySort,
      include: this.inventoryInclude,
      query: this.inventoryKeyword,
    });
    this.$root.$emit('rootResetFilter');
  }

  async deleteAllRequestFilters() {
    const groupId: string = this.$route.params.groupId;
    const status: any = this.$route.query.status;
    this.requestFilterStack = {
      Vendors: [],
      Manufacturers: [],
      Types: [],
      Users: [],
      Grants: [],
    };
    this.requestFilterObject = {
      Vendors: {
        subArray: [],
      },
      Manufacturers: {
        subArray: [],
      },
      Types: {
        subArray: [],
      },
      Users: {
        subArray: [],
      },
      Grants: {
        subArray: [],
      },
    };
    this.c_SET_REQUEST_FILTER({});
    await this.c_getRequests({
      groupId,
      attributes: this.queryAttributes,
      offset: this.queryOffset,
      limit: this.queryLimit,
      order: this.querySort,
      include: this.queryInclude,
      status: {
        status,
      },
      query: this.queryKeyword,
      hasDropdown: this.queryHasDropdown,
    });
    this.$root.$emit('rootResetFilter');
  }
}
